<script lang="ts" setup>
	defineProps<{
		tabList: lineTabContext[]
		active?: string
		useUrl?: boolean
		queryKey?: string
	}>()
	defineEmits<{
		(event: 'update:active', param: string | number): void
		(event: 'change', ...param: unknown): void
	}>()
</script>

<template>
	<tabs-pill
		:active-tab="active"
		:tabs="tabList"
		:use-default-wrapper-class="false"
		:ui="{
			tab: {
				active: {
					color: 'bg-primary-2'
				},
				inactive: {
					color: 'bg-gray-100 text-gray-400'
				},
				base: 'flex-1',
				rounded: ''
			},
			wrapper: {
				width: 'w-full'
			}
		}"
		body-class="border min-h-[400px]  w-full py-5 sm:px-5 px-5"
		:use-url="useUrl"
		:query-key
		@update:active-tab="item => $emit('update:active', item)"
		@change="$emit('change', $event)"
	>
		<template #default="content">
			<slot :key="content.key" :content="content.content" />
		</template>
	</tabs-pill>
</template>
